import config from "../../config";
const baseUrl = config.baseUrl;

export const JobUrls = {

 JOB_ADD: baseUrl + "/jobs",
 JOB_EDIT: baseUrl + "/jobs",
 JOB_STATUS: baseUrl + "/jobs/changedStatus",
 JOB_LIST: baseUrl + "/jobs",
 JOB_DELETE: baseUrl + "/jobs",
 JOB_GETBYID: baseUrl + "/jobs",
 JOB_ROLLBACK: baseUrl + "/jobs/rollback",
 JOB_DROPDOWN: baseUrl + "/jobs/dropdown?export=true", 
 JOB_DROPDOWN_HANDYMAN: baseUrl + "/jobs/dropdown?export=true&role=3", 
 JOB_DELETE_HARD: baseUrl + "/jobs",
 PATIENT_COUNT:baseUrl+"/patients/visitcount"
};